import React from "react";
import {Col, ColorPicker, Row, Space} from "antd";
import {ColumnProps} from "antd/es/table";
import Moment from "moment";
const columns: ColumnProps<any>[] = [
  {key: "id", title: "Mã", dataIndex: "id", align: "left"},
  {key: "tenChiSo", title: "Tên chỉ số", dataIndex: "tenChiSo", align: "left"},
  {
    key: "chiSoBinhThuongDuoi",
    title: "Chỉ số bình thường dưới",
    dataIndex: "chiSoBinhThuongDuoi",
  },
  {
    key: "chiSoBinhThuongTren",
    title: "Chỉ số bình thường trên",
    dataIndex: "chiSoBinhThuongTren",
  },
  {
    key: "chiSoBinhThuong",
    title: "Chỉ số bình thường",
    dataIndex: "chiSoBinhThuong",
  },
  {
    key: "chiSoKhongBinhThuong",
    title: "Chỉ số không bình thường",
    dataIndex: "chiSoKhongBinhThuong",
  },
  {key: "donViTinh", title: "Đơn vị", dataIndex: "donViTinh"},
  {key: "action", title: "Thao tác", dataIndex: "action"},
];
export {columns};
